import {endpoint} from "@/utils/api/Conf";
import {Paths} from "@/types/Paths";

export const pathsRequest = async (locale: string): Promise<Paths | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        "X-Language": locale || "it"
      }
    }
    return await fetch(endpoint + 'paths?page_size=50', init)
      .then((response) => response.json())
      .then((data: Paths) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
